export type SidebarOption = {
  id: number | string;
  name?: string;
  name_mn?: string;
  name_en?: string;
  children?: SidebarOption[];
  professions?: SidebarOption[];
};

export const getOptionLabel = (option: SidebarOption): string =>
  option.name_mn || option.name || option.name_en || '';

export const getOptionLabelByLang = (
  option: SidebarOption,
  isEnglish = false
): string =>
  isEnglish ? option.name_en || getOptionLabel(option) : getOptionLabel(option);

export const getUniqueId = (groupType: string, optionId: string): string =>
  `${groupType}-${optionId}`;

export const generateLink = (
  groupType: string,
  optionId: string,
  searchParams: URLSearchParams
) => {
  if (groupType === 'features') {
    if (optionId === 'near_me') {
      return '/job/near-me';
    }
    return `/job/list?type=${optionId}`;
  }
  const params = new URLSearchParams(searchParams.toString());
  if (params.get('branchId') === String(optionId)) {
    return `/job/list`;
  }
  return `/job/list?branchId=${optionId}`;
};
